import produce from 'immer';
import moment from 'moment-timezone';
import { isDateCondition } from 'app/views/layout/views/search/utils/date/isDateCondition';
/**
 * Creates read search results endpoint search params.
 *
 * @param type The search result type.
 * @param arg The read search api arg.
 */
export function createReadSearchResultsSearchParams(type, arg) {
    var _a;
    const strict = arg.strict;
    const facets = (_a = arg.filter) === null || _a === void 0 ? void 0 : _a.facets;
    const facetFilters = facets
        ? Object.keys(facets)
            .map((key) => [...new Set(facets[key])]
            .map((value) => [key, value].join(':'))
            .join(','))
            .join(',')
        : undefined;
    return {
        scope: type,
        strict,
        facetFilters,
    };
}
export function transformReadAdvancedSearchResultsArg({ type, params, }) {
    return {
        type,
        params: produce(params, (draftParams) => {
            var _a;
            if (draftParams.filters) {
                draftParams.filters.conditions.forEach((condition) => {
                    if (isDateCondition(condition)) {
                        condition.meta = { timezone: moment.tz.guess() };
                    }
                });
            }
            // Pagination is 1-based in the frontend and 0-based in the backend
            draftParams.page = ((_a = draftParams.page) !== null && _a !== void 0 ? _a : 1) - 1;
        }),
    };
}
